module.exports = __webpack_public_path__ + "static/media/magic-wand.635bccca.png";